import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Date: { input: string; output: string }
  DateTime: { input: string; output: string }
  JSON: { input: unknown; output: unknown }
}

export type AdminTenantCreateInput = {
  companyName: Scalars['String']['input']
  introductionDate?: InputMaybe<Scalars['Date']['input']>
  isKensetsuMode: Scalars['Boolean']['input']
  lastConversationDate?: InputMaybe<Scalars['Date']['input']>
  lastInterviewDate?: InputMaybe<Scalars['Date']['input']>
  memo: Scalars['String']['input']
  name: Scalars['String']['input']
  planId: Scalars['String']['input']
  prefecture: Scalars['String']['input']
  quoteNumber: Scalars['String']['input']
}

export type AdminTenantSettingUpdateInput = {
  tenantId: Scalars['String']['input']
}

export type AdminTenantUpdateInput = {
  companyName: Scalars['String']['input']
  id: Scalars['ID']['input']
  introductionDate?: InputMaybe<Scalars['Date']['input']>
  lastConversationDate?: InputMaybe<Scalars['Date']['input']>
  lastInterviewDate?: InputMaybe<Scalars['Date']['input']>
  memo: Scalars['String']['input']
  name: Scalars['String']['input']
  planId?: InputMaybe<Scalars['String']['input']>
  prefecture: Scalars['String']['input']
  quoteNumber?: InputMaybe<Scalars['String']['input']>
  status: TenantStatusEnum
}

export type AdminTenantsResponse = {
  __typename?: 'AdminTenantsResponse'
  tenants: Array<Tenant>
  total: Scalars['Int']['output']
}

export type CreateAdminInvitationInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  role: UserRoleEnum
  smsMfaRequired: Scalars['Boolean']['input']
  tenantId: Scalars['String']['input']
}

export type CreateInvitationInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  role: UserRoleEnum
  smsMfaRequired: Scalars['Boolean']['input']
}

export type CreateMillsheetsByCsvResult = {
  __typename?: 'CreateMillsheetsByCsvResult'
  index: Scalars['Int']['output']
  isEmptyLine?: Maybe<Scalars['Boolean']['output']>
  message?: Maybe<Scalars['String']['output']>
  resultTitle?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DashboardResponse = {
  __typename?: 'DashboardResponse'
  millsheetsCount: Scalars['Int']['output']
  tenantPlan?: Maybe<TenantPlan>
}

export const IdentityRoleEnum = {
  Admin: 'admin',
  Member: 'member',
} as const

export type IdentityRoleEnum = (typeof IdentityRoleEnum)[keyof typeof IdentityRoleEnum]
export type Me = {
  __typename?: 'Me'
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  role: UserRoleEnum
  tenant: MyTenant
}

export type Millsheet = {
  __typename?: 'Millsheet'
  constructionArea: Scalars['String']['output']
  constructionName: Scalars['String']['output']
  customer: Scalars['String']['output']
  id: Scalars['ID']['output']
  innerNo: Scalars['String']['output']
  issuedDate: Scalars['Date']['output']
  manufacturerName: Scalars['String']['output']
  member: Scalars['String']['output']
  millsheetItems: Array<MillsheetItem>
  no: Scalars['String']['output']
  orderNumber: Scalars['String']['output']
  s3Object?: Maybe<S3Object>
  submissionDate?: Maybe<Scalars['Date']['output']>
  tenantId: Scalars['String']['output']
  tradingCompany: Scalars['String']['output']
}

export type MillsheetItem = {
  __typename?: 'MillsheetItem'
  heatNumber: Scalars['String']['output']
  id: Scalars['ID']['output']
  individualNumber: Scalars['String']['output']
  length: Scalars['String']['output']
  millsheetNo?: Maybe<Scalars['String']['output']>
  quantity: Scalars['Int']['output']
  rank: Scalars['Int']['output']
  sectionType: Scalars['String']['output']
  size: Scalars['String']['output']
  steelType: Scalars['String']['output']
  tenantId: Scalars['String']['output']
  weightBeforeProcessing: Maybe<Scalars['Int']['output']>
}

export type MillsheetSortConfig = {
  __typename?: 'MillsheetSortConfig'
  manufacturerName?: Maybe<Array<Scalars['String']['output']>>
  sectionType?: Maybe<Array<Scalars['String']['output']>>
  steelType?: Maybe<Array<Scalars['String']['output']>>
}

export type MillsheetSortConfigInput = {
  manufacturerName?: InputMaybe<Array<Scalars['String']['input']>>
  sectionType?: InputMaybe<Array<Scalars['String']['input']>>
  steelType?: InputMaybe<Array<Scalars['String']['input']>>
}

export type MillsheetUpdateInput = {
  id: Scalars['ID']['input']
  submissionDate?: InputMaybe<Scalars['Date']['input']>
}

export type MillsheetsUpdateInput = {
  ids: Array<Scalars['ID']['input']>
  submissionDate?: InputMaybe<Scalars['Date']['input']>
}

export type Mutation = {
  __typename?: 'Mutation'
  agreeToServiceTerms: Me
  createAdminInvitation: User
  createAdminPlan?: Maybe<Plan>
  createAdminTenant?: Maybe<Tenant>
  createInvitation: User
  createMillsheetsByCsv: Array<CreateMillsheetsByCsvResult>
  createS3Object?: Maybe<S3Object>
  createS3ObjectThumbnails?: Maybe<S3Object>
  deleteAdminPlan?: Maybe<Plan>
  deleteAdminTenant?: Maybe<Tenant>
  deleteAdminUser?: Maybe<User>
  deleteMillsheet?: Maybe<Millsheet>
  deleteS3Object?: Maybe<S3Object>
  deleteUser?: Maybe<User>
  updateAdminPlan?: Maybe<Plan>
  updateAdminTenant?: Maybe<Tenant>
  updateMillsheet?: Maybe<Millsheet>
  updateMillsheets: Array<Millsheet>
  updateS3Object?: Maybe<S3Object>
  updateTenantSetting?: Maybe<TenantSetting>
  updateUser?: Maybe<User>
  upsertAdminTenantSetting: TenantSetting
}

export type MutationCreateAdminInvitationArgs = {
  input: CreateAdminInvitationInput
}

export type MutationCreateAdminPlanArgs = {
  plan: PlanCreateInput
}

export type MutationCreateAdminTenantArgs = {
  tenant: AdminTenantCreateInput
}

export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput
}

export type MutationCreateMillsheetsByCsvArgs = {
  csv: Scalars['String']['input']
}

export type MutationCreateS3ObjectArgs = {
  input: S3ObjectCreateInput
}

export type MutationCreateS3ObjectThumbnailsArgs = {
  s3ObjectId: Scalars['ID']['input']
}

export type MutationDeleteAdminPlanArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteAdminTenantArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteAdminUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteMillsheetArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteS3ObjectArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationUpdateAdminPlanArgs = {
  plan: PlanUpdateInput
}

export type MutationUpdateAdminTenantArgs = {
  tenant: AdminTenantUpdateInput
}

export type MutationUpdateMillsheetArgs = {
  input: MillsheetUpdateInput
}

export type MutationUpdateMillsheetsArgs = {
  input: MillsheetsUpdateInput
}

export type MutationUpdateS3ObjectArgs = {
  input: S3ObjectUpdateInput
}

export type MutationUpdateTenantSettingArgs = {
  input: TenantSettingUpdateInput
}

export type MutationUpdateUserArgs = {
  input: UserInput
}

export type MutationUpsertAdminTenantSettingArgs = {
  input: AdminTenantSettingUpdateInput
}

export type MyIdentity = {
  __typename?: 'MyIdentity'
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  role: IdentityRoleEnum
  users: Array<Me>
}

export type MyTenant = {
  __typename?: 'MyTenant'
  companyName: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  memo: Scalars['String']['output']
  name: Scalars['String']['output']
  prefecture: Scalars['String']['output']
  setting?: Maybe<TenantSetting>
  status: TenantStatusEnum
  tenantPlan?: Maybe<TenantPlan>
}

/** サービスプラン情報 */
export type Plan = {
  __typename?: 'Plan'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  /** プラン名称 */
  name: Scalars['String']['output']
  /** 利用条件（マークダウン形式） */
  serviceTerms: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type PlanCreateInput = {
  name: Scalars['String']['input']
  serviceTerms: Scalars['String']['input']
}

export type PlanUpdateInput = {
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  serviceTerms: Scalars['String']['input']
}

export type Query = {
  __typename?: 'Query'
  adminPlans: Array<Plan>
  adminS3Object: S3Object
  adminTenant: Tenant
  adminTenants: AdminTenantsResponse
  dashboard: DashboardResponse
  me: Me
  millsheetItems: Array<MillsheetItem>
  millsheets: Array<Millsheet>
  myIdentity: MyIdentity
  s3Objects: Array<S3Object>
  users: Array<User>
}

export type QueryAdminS3ObjectArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminTenantArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminTenantsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMillsheetItemsArgs = {
  heatNumber: Scalars['String']['input']
}

export type QueryS3ObjectsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>
  notConnectedOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type S3Object = {
  __typename?: 'S3Object'
  contentLength: Scalars['Int']['output']
  contentType: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  extension: Scalars['String']['output']
  fileUrl: Scalars['String']['output']
  fileUrlForPut: Scalars['String']['output']
  id: Scalars['ID']['output']
  imageHeight?: Maybe<Scalars['Int']['output']>
  imageWidth?: Maybe<Scalars['Int']['output']>
  originalFileName: Scalars['String']['output']
  resourceType: S3ObjectResourceTypeEnum
  thumbnailCount?: Maybe<Scalars['Int']['output']>
  thumbnailFileUrls: Array<Scalars['String']['output']>
}

export type S3ObjectCreateInput = {
  contentLength: Scalars['Int']['input']
  contentType: Scalars['String']['input']
  originalFileName: Scalars['String']['input']
  resourceType: S3ObjectResourceTypeEnum
}

export const S3ObjectResourceTypeEnum = {
  Millsheets: 'millsheets',
} as const

export type S3ObjectResourceTypeEnum = (typeof S3ObjectResourceTypeEnum)[keyof typeof S3ObjectResourceTypeEnum]
export type S3ObjectUpdateInput = {
  id: Scalars['ID']['input']
  millsheetId?: InputMaybe<Scalars['String']['input']>
}

export type Tenant = {
  __typename?: 'Tenant'
  companyName: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  introductionDate?: Maybe<Scalars['Date']['output']>
  lastConversationDate?: Maybe<Scalars['Date']['output']>
  lastInterviewDate?: Maybe<Scalars['Date']['output']>
  memo: Scalars['String']['output']
  name: Scalars['String']['output']
  prefecture: Scalars['String']['output']
  /** テナントの設定情報 */
  setting?: Maybe<TenantSetting>
  /** テナントのステータス */
  status: TenantStatusEnum
  /** テナントのプラン情報 */
  tenantPlan?: Maybe<TenantPlan>
  updatedAt: Scalars['DateTime']['output']
  users: Array<User>
}

/** テナントとプランの関連情報 */
export type TenantPlan = {
  __typename?: 'TenantPlan'
  /** 同意日時 */
  agreedAt?: Maybe<Scalars['DateTime']['output']>
  /** 同意したユーザーID */
  agreedById?: Maybe<Scalars['String']['output']>
  agreedByUser?: Maybe<User>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  plan: Plan
  planId: Scalars['String']['output']
  /** 見積番号 */
  quoteNumber: Scalars['String']['output']
  tenantId: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type TenantSetting = {
  __typename?: 'TenantSetting'
  id: Scalars['ID']['output']
  millsheetSortConfig?: Maybe<MillsheetSortConfig>
}

export type TenantSettingUpdateInput = {
  millsheetSortConfig?: InputMaybe<MillsheetSortConfigInput>
}

/** テナントの状態を表す列挙型 */
export const TenantStatusEnum = {
  Active: 'active',
  PreActive: 'preActive',
  Suspended: 'suspended',
  Trial: 'trial',
} as const

export type TenantStatusEnum = (typeof TenantStatusEnum)[keyof typeof TenantStatusEnum]
export type User = {
  __typename?: 'User'
  createdAt: Scalars['DateTime']['output']
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  role: UserRoleEnum
  signedUpAt?: Maybe<Scalars['DateTime']['output']>
  smsMfaRequired: Scalars['Boolean']['output']
}

export type UserInput = {
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  role?: InputMaybe<UserRoleEnum>
  smsMfaRequired?: InputMaybe<Scalars['Boolean']['input']>
}

export const UserRoleEnum = {
  Admin: 'admin',
  Manager: 'manager',
  Member: 'member',
} as const

export type UserRoleEnum = (typeof UserRoleEnum)[keyof typeof UserRoleEnum]
export type CreateMillsheetsByCsvResultFieldsFragment = {
  __typename?: 'CreateMillsheetsByCsvResult'
  index: number
  success: boolean
  isEmptyLine?: boolean | null
  message?: string | null
  resultTitle?: string | null
}

export type MeFieldsFragment = {
  __typename?: 'Me'
  id: string
  name: string
  email: string
  imageUrl?: string | null
  role: UserRoleEnum
  tenant: {
    __typename?: 'MyTenant'
    id: string
    name: string
    companyName: string
    prefecture: string
    memo: string
    status: TenantStatusEnum
    createdAt: string
    setting?: {
      __typename?: 'TenantSetting'
      id: string
      millsheetSortConfig?: {
        __typename?: 'MillsheetSortConfig'
        manufacturerName?: Array<string> | null
        steelType?: Array<string> | null
        sectionType?: Array<string> | null
      } | null
    } | null
  }
}

export type MillsheetFieldsFragment = {
  __typename?: 'Millsheet'
  id: string
  tenantId: string
  no: string
  manufacturerName: string
  issuedDate: string
  submissionDate?: string | null
  tradingCompany: string
  customer: string
  constructionArea: string
  member: string
  constructionName: string
  orderNumber: string
  innerNo: string
  millsheetItems: Array<{
    __typename?: 'MillsheetItem'
    id: string
    heatNumber: string
    individualNumber: string
    steelType: string
    sectionType: string
    quantity: number
    size: string
    weightBeforeProcessing: number | null
    length: string
    rank: number
  }>
  s3Object?: { __typename?: 'S3Object'; id: string; resourceType: S3ObjectResourceTypeEnum } | null
}

export type MillsheetItemFieldsFragment = {
  __typename?: 'MillsheetItem'
  id: string
  heatNumber: string
  individualNumber: string
  steelType: string
  sectionType: string
  quantity: number
  size: string
  weightBeforeProcessing: number | null
  length: string
  rank: number
}

export type MyIdentityFieldsFragment = {
  __typename?: 'MyIdentity'
  id: string
  email: string
  role: IdentityRoleEnum
  users: Array<{
    __typename?: 'Me'
    id: string
    name: string
    email: string
    imageUrl?: string | null
    role: UserRoleEnum
    tenant: {
      __typename?: 'MyTenant'
      id: string
      name: string
      companyName: string
      prefecture: string
      memo: string
      status: TenantStatusEnum
      createdAt: string
      setting?: {
        __typename?: 'TenantSetting'
        id: string
        millsheetSortConfig?: {
          __typename?: 'MillsheetSortConfig'
          manufacturerName?: Array<string> | null
          steelType?: Array<string> | null
          sectionType?: Array<string> | null
        } | null
      } | null
    }
  }>
}

export type MyTenantFieldsFragment = {
  __typename?: 'MyTenant'
  id: string
  name: string
  companyName: string
  prefecture: string
  memo: string
  status: TenantStatusEnum
  createdAt: string
  setting?: {
    __typename?: 'TenantSetting'
    id: string
    millsheetSortConfig?: {
      __typename?: 'MillsheetSortConfig'
      manufacturerName?: Array<string> | null
      steelType?: Array<string> | null
      sectionType?: Array<string> | null
    } | null
  } | null
}

export type PlanFieldsFragment = { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }

export type TenantFieldsFragment = {
  __typename?: 'Tenant'
  id: string
  name: string
  companyName: string
  prefecture: string
  memo: string
  status: TenantStatusEnum
  introductionDate?: string | null
  lastConversationDate?: string | null
  lastInterviewDate?: string | null
  createdAt: string
  setting?: {
    __typename?: 'TenantSetting'
    id: string
    millsheetSortConfig?: {
      __typename?: 'MillsheetSortConfig'
      manufacturerName?: Array<string> | null
      steelType?: Array<string> | null
      sectionType?: Array<string> | null
    } | null
  } | null
  users: Array<{
    __typename?: 'User'
    id: string
    name: string
    email: string
    role: UserRoleEnum
    smsMfaRequired: boolean
    createdAt: string
    signedUpAt?: string | null
  }>
  tenantPlan?: {
    __typename?: 'TenantPlan'
    id: string
    planId: string
    quoteNumber: string
    plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
  } | null
}

export type TenantSimpleFieldsFragment = {
  __typename?: 'Tenant'
  id: string
  name: string
  companyName: string
  prefecture: string
  status: TenantStatusEnum
  memo: string
  introductionDate?: string | null
  lastConversationDate?: string | null
  lastInterviewDate?: string | null
  createdAt: string
  tenantPlan?: {
    __typename?: 'TenantPlan'
    id: string
    planId: string
    quoteNumber: string
    plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
  } | null
}

export type TenantSettingFieldsFragment = {
  __typename?: 'TenantSetting'
  id: string
  millsheetSortConfig?: {
    __typename?: 'MillsheetSortConfig'
    manufacturerName?: Array<string> | null
    steelType?: Array<string> | null
    sectionType?: Array<string> | null
  } | null
}

export type UserFieldsFragment = {
  __typename?: 'User'
  id: string
  name: string
  email: string
  role: UserRoleEnum
  smsMfaRequired: boolean
  createdAt: string
  signedUpAt?: string | null
}

export type CreateInvitationMutationVariables = Exact<{
  input: CreateInvitationInput
}>

export type CreateInvitationMutation = {
  __typename?: 'Mutation'
  createInvitation: {
    __typename?: 'User'
    id: string
    name: string
    email: string
    role: UserRoleEnum
    smsMfaRequired: boolean
    createdAt: string
    signedUpAt?: string | null
  }
}

export type AgreeToServiceTermsMutationVariables = Exact<{ [key: string]: never }>

export type AgreeToServiceTermsMutation = {
  __typename?: 'Mutation'
  agreeToServiceTerms: {
    __typename?: 'Me'
    id: string
    name: string
    email: string
    imageUrl?: string | null
    role: UserRoleEnum
    tenant: {
      __typename?: 'MyTenant'
      id: string
      name: string
      companyName: string
      prefecture: string
      memo: string
      status: TenantStatusEnum
      createdAt: string
      setting?: {
        __typename?: 'TenantSetting'
        id: string
        millsheetSortConfig?: {
          __typename?: 'MillsheetSortConfig'
          manufacturerName?: Array<string> | null
          steelType?: Array<string> | null
          sectionType?: Array<string> | null
        } | null
      } | null
    }
  }
}

export type CreateAdminInvitationMutationVariables = Exact<{
  input: CreateAdminInvitationInput
}>

export type CreateAdminInvitationMutation = {
  __typename?: 'Mutation'
  createAdminInvitation: {
    __typename?: 'User'
    id: string
    name: string
    email: string
    role: UserRoleEnum
    smsMfaRequired: boolean
    createdAt: string
    signedUpAt?: string | null
  }
}

export type CreateAdminPlanMutationVariables = Exact<{
  plan: PlanCreateInput
}>

export type CreateAdminPlanMutation = {
  __typename?: 'Mutation'
  createAdminPlan?: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string } | null
}

export type CreateMillsheetsByCsvMutationVariables = Exact<{
  csv: Scalars['String']['input']
}>

export type CreateMillsheetsByCsvMutation = {
  __typename?: 'Mutation'
  createMillsheetsByCsv: Array<{
    __typename?: 'CreateMillsheetsByCsvResult'
    index: number
    success: boolean
    isEmptyLine?: boolean | null
    message?: string | null
    resultTitle?: string | null
  }>
}

export type CreateS3ObjectMutationVariables = Exact<{
  input: S3ObjectCreateInput
}>

export type CreateS3ObjectMutation = {
  __typename?: 'Mutation'
  createS3Object?: { __typename?: 'S3Object'; id: string; fileUrl: string; fileUrlForPut: string } | null
}

export type CreateS3ObjectThumbnailsMutationVariables = Exact<{
  s3ObjectId: Scalars['ID']['input']
}>

export type CreateS3ObjectThumbnailsMutation = {
  __typename?: 'Mutation'
  createS3ObjectThumbnails?: {
    __typename?: 'S3Object'
    id: string
    fileUrl: string
    thumbnailFileUrls: Array<string>
  } | null
}

export type CreateTenantMutationVariables = Exact<{
  tenant: AdminTenantCreateInput
}>

export type CreateTenantMutation = {
  __typename?: 'Mutation'
  createAdminTenant?: {
    __typename?: 'Tenant'
    id: string
    name: string
    companyName: string
    prefecture: string
    memo: string
    status: TenantStatusEnum
    introductionDate?: string | null
    lastConversationDate?: string | null
    lastInterviewDate?: string | null
    createdAt: string
    setting?: {
      __typename?: 'TenantSetting'
      id: string
      millsheetSortConfig?: {
        __typename?: 'MillsheetSortConfig'
        manufacturerName?: Array<string> | null
        steelType?: Array<string> | null
        sectionType?: Array<string> | null
      } | null
    } | null
    users: Array<{
      __typename?: 'User'
      id: string
      name: string
      email: string
      role: UserRoleEnum
      smsMfaRequired: boolean
      createdAt: string
      signedUpAt?: string | null
    }>
    tenantPlan?: {
      __typename?: 'TenantPlan'
      id: string
      planId: string
      quoteNumber: string
      plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
    } | null
  } | null
}

export type DeleteAdminPlanMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteAdminPlanMutation = {
  __typename?: 'Mutation'
  deleteAdminPlan?: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string } | null
}

export type DeleteAdminUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteAdminUserMutation = {
  __typename?: 'Mutation'
  deleteAdminUser?: { __typename?: 'User'; id: string } | null
}

export type DeleteMillsheetMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteMillsheetMutation = {
  __typename?: 'Mutation'
  deleteMillsheet?: {
    __typename?: 'Millsheet'
    id: string
    tenantId: string
    no: string
    manufacturerName: string
    issuedDate: string
    submissionDate?: string | null
    tradingCompany: string
    customer: string
    constructionArea: string
    member: string
    constructionName: string
    orderNumber: string
    innerNo: string
    millsheetItems: Array<{
      __typename?: 'MillsheetItem'
      id: string
      heatNumber: string
      individualNumber: string
      steelType: string
      sectionType: string
      quantity: number
      size: string
      weightBeforeProcessing: number | null
      length: string
      rank: number
    }>
    s3Object?: { __typename?: 'S3Object'; id: string; resourceType: S3ObjectResourceTypeEnum } | null
  } | null
}

export type DeleteS3ObjectMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteS3ObjectMutation = {
  __typename?: 'Mutation'
  deleteS3Object?: { __typename?: 'S3Object'; id: string } | null
}

export type DeleteTenantMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteTenantMutation = {
  __typename?: 'Mutation'
  deleteAdminTenant?: {
    __typename?: 'Tenant'
    id: string
    name: string
    companyName: string
    prefecture: string
    memo: string
    status: TenantStatusEnum
    introductionDate?: string | null
    lastConversationDate?: string | null
    lastInterviewDate?: string | null
    createdAt: string
    setting?: {
      __typename?: 'TenantSetting'
      id: string
      millsheetSortConfig?: {
        __typename?: 'MillsheetSortConfig'
        manufacturerName?: Array<string> | null
        steelType?: Array<string> | null
        sectionType?: Array<string> | null
      } | null
    } | null
    users: Array<{
      __typename?: 'User'
      id: string
      name: string
      email: string
      role: UserRoleEnum
      smsMfaRequired: boolean
      createdAt: string
      signedUpAt?: string | null
    }>
    tenantPlan?: {
      __typename?: 'TenantPlan'
      id: string
      planId: string
      quoteNumber: string
      plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
    } | null
  } | null
}

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteUserMutation = { __typename?: 'Mutation'; deleteUser?: { __typename?: 'User'; id: string } | null }

export type UpdateAdminPlanMutationVariables = Exact<{
  plan: PlanUpdateInput
}>

export type UpdateAdminPlanMutation = {
  __typename?: 'Mutation'
  updateAdminPlan?: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string } | null
}

export type UpdateMillsheetMutationVariables = Exact<{
  input: MillsheetUpdateInput
}>

export type UpdateMillsheetMutation = {
  __typename?: 'Mutation'
  updateMillsheet?: {
    __typename?: 'Millsheet'
    id: string
    tenantId: string
    no: string
    manufacturerName: string
    issuedDate: string
    submissionDate?: string | null
    tradingCompany: string
    customer: string
    constructionArea: string
    member: string
    constructionName: string
    orderNumber: string
    innerNo: string
    millsheetItems: Array<{
      __typename?: 'MillsheetItem'
      id: string
      heatNumber: string
      individualNumber: string
      steelType: string
      sectionType: string
      quantity: number
      size: string
      weightBeforeProcessing: number | null
      length: string
      rank: number
    }>
    s3Object?: { __typename?: 'S3Object'; id: string; resourceType: S3ObjectResourceTypeEnum } | null
  } | null
}

export type UpdateMillsheetsMutationVariables = Exact<{
  input: MillsheetsUpdateInput
}>

export type UpdateMillsheetsMutation = {
  __typename?: 'Mutation'
  updateMillsheets: Array<{
    __typename?: 'Millsheet'
    id: string
    tenantId: string
    no: string
    manufacturerName: string
    issuedDate: string
    submissionDate?: string | null
    tradingCompany: string
    customer: string
    constructionArea: string
    member: string
    constructionName: string
    orderNumber: string
    innerNo: string
    millsheetItems: Array<{
      __typename?: 'MillsheetItem'
      id: string
      heatNumber: string
      individualNumber: string
      steelType: string
      sectionType: string
      quantity: number
      size: string
      weightBeforeProcessing: number | null
      length: string
      rank: number
    }>
    s3Object?: { __typename?: 'S3Object'; id: string; resourceType: S3ObjectResourceTypeEnum } | null
  }>
}

export type UpdateS3ObjectMutationVariables = Exact<{
  input: S3ObjectUpdateInput
}>

export type UpdateS3ObjectMutation = {
  __typename?: 'Mutation'
  updateS3Object?: { __typename?: 'S3Object'; id: string } | null
}

export type UpdateTenantMutationVariables = Exact<{
  tenant: AdminTenantUpdateInput
}>

export type UpdateTenantMutation = {
  __typename?: 'Mutation'
  updateAdminTenant?: {
    __typename?: 'Tenant'
    id: string
    name: string
    companyName: string
    prefecture: string
    memo: string
    status: TenantStatusEnum
    introductionDate?: string | null
    lastConversationDate?: string | null
    lastInterviewDate?: string | null
    createdAt: string
    setting?: {
      __typename?: 'TenantSetting'
      id: string
      millsheetSortConfig?: {
        __typename?: 'MillsheetSortConfig'
        manufacturerName?: Array<string> | null
        steelType?: Array<string> | null
        sectionType?: Array<string> | null
      } | null
    } | null
    users: Array<{
      __typename?: 'User'
      id: string
      name: string
      email: string
      role: UserRoleEnum
      smsMfaRequired: boolean
      createdAt: string
      signedUpAt?: string | null
    }>
    tenantPlan?: {
      __typename?: 'TenantPlan'
      id: string
      planId: string
      quoteNumber: string
      plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
    } | null
  } | null
}

export type UpdateTenantSettingMutationVariables = Exact<{
  input: TenantSettingUpdateInput
}>

export type UpdateTenantSettingMutation = {
  __typename?: 'Mutation'
  updateTenantSetting?: {
    __typename?: 'TenantSetting'
    id: string
    millsheetSortConfig?: {
      __typename?: 'MillsheetSortConfig'
      manufacturerName?: Array<string> | null
      steelType?: Array<string> | null
      sectionType?: Array<string> | null
    } | null
  } | null
}

export type UpdateUserMutationVariables = Exact<{
  input: UserInput
}>

export type UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser?: {
    __typename?: 'User'
    id: string
    name: string
    email: string
    role: UserRoleEnum
    smsMfaRequired: boolean
    createdAt: string
    signedUpAt?: string | null
  } | null
}

export type UpsertAdminTenantSettingMutationVariables = Exact<{
  tenantSetting: AdminTenantSettingUpdateInput
}>

export type UpsertAdminTenantSettingMutation = {
  __typename?: 'Mutation'
  upsertAdminTenantSetting: {
    __typename?: 'TenantSetting'
    id: string
    millsheetSortConfig?: {
      __typename?: 'MillsheetSortConfig'
      manufacturerName?: Array<string> | null
      steelType?: Array<string> | null
      sectionType?: Array<string> | null
    } | null
  }
}

export type FetchAdminS3ObjectQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FetchAdminS3ObjectQuery = {
  __typename?: 'Query'
  adminS3Object: {
    __typename?: 'S3Object'
    id: string
    originalFileName: string
    resourceType: S3ObjectResourceTypeEnum
    extension: string
    contentType: string
    contentLength: number
    thumbnailCount?: number | null
    imageWidth?: number | null
    imageHeight?: number | null
    fileUrl: string
    createdAt: string
    thumbnailFileUrls: Array<string>
  }
}

export type FetchAdminTenantsQueryVariables = Exact<{ [key: string]: never }>

export type FetchAdminTenantsQuery = {
  __typename?: 'Query'
  adminTenants: {
    __typename?: 'AdminTenantsResponse'
    total: number
    tenants: Array<{
      __typename?: 'Tenant'
      id: string
      name: string
      companyName: string
      prefecture: string
      memo: string
      status: TenantStatusEnum
      introductionDate?: string | null
      lastConversationDate?: string | null
      lastInterviewDate?: string | null
      createdAt: string
      setting?: {
        __typename?: 'TenantSetting'
        id: string
        millsheetSortConfig?: {
          __typename?: 'MillsheetSortConfig'
          manufacturerName?: Array<string> | null
          steelType?: Array<string> | null
          sectionType?: Array<string> | null
        } | null
      } | null
      users: Array<{
        __typename?: 'User'
        id: string
        name: string
        email: string
        role: UserRoleEnum
        smsMfaRequired: boolean
        createdAt: string
        signedUpAt?: string | null
      }>
      tenantPlan?: {
        __typename?: 'TenantPlan'
        id: string
        planId: string
        quoteNumber: string
        plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
      } | null
    }>
  }
}

export type FetchDashboardQueryVariables = Exact<{ [key: string]: never }>

export type FetchDashboardQuery = {
  __typename?: 'Query'
  dashboard: {
    __typename?: 'DashboardResponse'
    millsheetsCount: number
    tenantPlan?: {
      __typename?: 'TenantPlan'
      id: string
      quoteNumber: string
      plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
    } | null
  }
}

export type FetchMeQueryVariables = Exact<{ [key: string]: never }>

export type FetchMeQuery = {
  __typename?: 'Query'
  me: {
    __typename?: 'Me'
    id: string
    name: string
    email: string
    imageUrl?: string | null
    role: UserRoleEnum
    tenant: {
      __typename?: 'MyTenant'
      id: string
      name: string
      companyName: string
      prefecture: string
      memo: string
      status: TenantStatusEnum
      createdAt: string
      setting?: {
        __typename?: 'TenantSetting'
        id: string
        millsheetSortConfig?: {
          __typename?: 'MillsheetSortConfig'
          manufacturerName?: Array<string> | null
          steelType?: Array<string> | null
          sectionType?: Array<string> | null
        } | null
      } | null
    }
  }
}

export type FetchMillsheetItemsQueryVariables = Exact<{
  heatNumber: Scalars['String']['input']
}>

export type FetchMillsheetItemsQuery = {
  __typename?: 'Query'
  millsheetItems: Array<{
    __typename?: 'MillsheetItem'
    millsheetNo?: string | null
    id: string
    heatNumber: string
    individualNumber: string
    steelType: string
    sectionType: string
    quantity: number
    size: string
    weightBeforeProcessing: number | null
    length: string
    rank: number
  }>
}

export type FetchMillsheetsQueryVariables = Exact<{ [key: string]: never }>

export type FetchMillsheetsQuery = {
  __typename?: 'Query'
  millsheets: Array<{
    __typename?: 'Millsheet'
    id: string
    tenantId: string
    no: string
    manufacturerName: string
    issuedDate: string
    submissionDate?: string | null
    tradingCompany: string
    customer: string
    constructionArea: string
    member: string
    constructionName: string
    orderNumber: string
    innerNo: string
    millsheetItems: Array<{
      __typename?: 'MillsheetItem'
      id: string
      heatNumber: string
      individualNumber: string
      steelType: string
      sectionType: string
      quantity: number
      size: string
      weightBeforeProcessing: number | null
      length: string
      rank: number
    }>
    s3Object?: { __typename?: 'S3Object'; id: string; resourceType: S3ObjectResourceTypeEnum } | null
  }>
}

export type FetchMyIdentityQueryVariables = Exact<{ [key: string]: never }>

export type FetchMyIdentityQuery = {
  __typename?: 'Query'
  myIdentity: {
    __typename?: 'MyIdentity'
    id: string
    email: string
    role: IdentityRoleEnum
    users: Array<{
      __typename?: 'Me'
      id: string
      name: string
      email: string
      imageUrl?: string | null
      role: UserRoleEnum
      tenant: {
        __typename?: 'MyTenant'
        id: string
        name: string
        companyName: string
        prefecture: string
        memo: string
        status: TenantStatusEnum
        createdAt: string
        setting?: {
          __typename?: 'TenantSetting'
          id: string
          millsheetSortConfig?: {
            __typename?: 'MillsheetSortConfig'
            manufacturerName?: Array<string> | null
            steelType?: Array<string> | null
            sectionType?: Array<string> | null
          } | null
        } | null
      }
    }>
  }
}

export type FetchMyTenantDetailQueryVariables = Exact<{ [key: string]: never }>

export type FetchMyTenantDetailQuery = {
  __typename?: 'Query'
  me: {
    __typename?: 'Me'
    name: string
    tenant: {
      __typename?: 'MyTenant'
      name: string
      tenantPlan?: {
        __typename?: 'TenantPlan'
        id: string
        quoteNumber: string
        plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
      } | null
    }
  }
}

export type FetchAdminPlansQueryVariables = Exact<{ [key: string]: never }>

export type FetchAdminPlansQuery = {
  __typename?: 'Query'
  adminPlans: Array<{ __typename?: 'Plan'; id: string; name: string; serviceTerms: string }>
}

export type FetchS3ObjectsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  notConnectedOnly?: InputMaybe<Scalars['Boolean']['input']>
}>

export type FetchS3ObjectsQuery = {
  __typename?: 'Query'
  s3Objects: Array<{
    __typename?: 'S3Object'
    id: string
    originalFileName: string
    resourceType: S3ObjectResourceTypeEnum
    extension: string
    contentType: string
    contentLength: number
    thumbnailCount?: number | null
    imageWidth?: number | null
    imageHeight?: number | null
    fileUrl: string
    createdAt: string
    thumbnailFileUrls: Array<string>
  }>
}

export type FetchTenantQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FetchTenantQuery = {
  __typename?: 'Query'
  adminTenant: {
    __typename?: 'Tenant'
    id: string
    name: string
    companyName: string
    prefecture: string
    memo: string
    status: TenantStatusEnum
    introductionDate?: string | null
    lastConversationDate?: string | null
    lastInterviewDate?: string | null
    createdAt: string
    setting?: {
      __typename?: 'TenantSetting'
      id: string
      millsheetSortConfig?: {
        __typename?: 'MillsheetSortConfig'
        manufacturerName?: Array<string> | null
        steelType?: Array<string> | null
        sectionType?: Array<string> | null
      } | null
    } | null
    users: Array<{
      __typename?: 'User'
      id: string
      name: string
      email: string
      role: UserRoleEnum
      smsMfaRequired: boolean
      createdAt: string
      signedUpAt?: string | null
    }>
    tenantPlan?: {
      __typename?: 'TenantPlan'
      id: string
      planId: string
      quoteNumber: string
      plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
    } | null
  }
}

export type FetchTenantsQueryVariables = Exact<{ [key: string]: never }>

export type FetchTenantsQuery = {
  __typename?: 'Query'
  adminTenants: {
    __typename?: 'AdminTenantsResponse'
    total: number
    tenants: Array<{
      __typename?: 'Tenant'
      id: string
      name: string
      companyName: string
      prefecture: string
      status: TenantStatusEnum
      memo: string
      introductionDate?: string | null
      lastConversationDate?: string | null
      lastInterviewDate?: string | null
      createdAt: string
      tenantPlan?: {
        __typename?: 'TenantPlan'
        id: string
        planId: string
        quoteNumber: string
        plan: { __typename?: 'Plan'; id: string; name: string; serviceTerms: string }
      } | null
    }>
  }
}

export type FetchUsersQueryVariables = Exact<{ [key: string]: never }>

export type FetchUsersQuery = {
  __typename?: 'Query'
  users: Array<{
    __typename?: 'User'
    id: string
    name: string
    email: string
    role: UserRoleEnum
    smsMfaRequired: boolean
    createdAt: string
    signedUpAt?: string | null
  }>
}

export const CreateMillsheetsByCsvResultFieldsFragmentDoc = gql`
  fragment CreateMillsheetsByCsvResultFields on CreateMillsheetsByCsvResult {
    index
    success
    isEmptyLine
    message
    resultTitle
  }
`
export const MillsheetItemFieldsFragmentDoc = gql`
  fragment MillsheetItemFields on MillsheetItem {
    id
    heatNumber
    individualNumber
    steelType
    sectionType
    quantity
    size
    weightBeforeProcessing
    length
    rank
  }
`
export const MillsheetFieldsFragmentDoc = gql`
  fragment MillsheetFields on Millsheet {
    id
    tenantId
    no
    manufacturerName
    issuedDate
    submissionDate
    tradingCompany
    customer
    constructionArea
    member
    constructionName
    orderNumber
    innerNo
    millsheetItems {
      ...MillsheetItemFields
    }
    s3Object {
      id
      resourceType
    }
  }
  ${MillsheetItemFieldsFragmentDoc}
`
export const TenantSettingFieldsFragmentDoc = gql`
  fragment TenantSettingFields on TenantSetting {
    id
    millsheetSortConfig {
      manufacturerName
      steelType
      sectionType
    }
  }
`
export const MyTenantFieldsFragmentDoc = gql`
  fragment MyTenantFields on MyTenant {
    id
    name
    companyName
    prefecture
    memo
    status
    createdAt
    setting {
      ...TenantSettingFields
    }
  }
  ${TenantSettingFieldsFragmentDoc}
`
export const MeFieldsFragmentDoc = gql`
  fragment MeFields on Me {
    id
    name
    email
    imageUrl
    role
    tenant {
      ...MyTenantFields
    }
  }
  ${MyTenantFieldsFragmentDoc}
`
export const MyIdentityFieldsFragmentDoc = gql`
  fragment MyIdentityFields on MyIdentity {
    id
    email
    role
    users {
      ...MeFields
    }
  }
  ${MeFieldsFragmentDoc}
`
export const UserFieldsFragmentDoc = gql`
  fragment UserFields on User {
    id
    name
    email
    role
    smsMfaRequired
    createdAt
    signedUpAt
  }
`
export const PlanFieldsFragmentDoc = gql`
  fragment PlanFields on Plan {
    id
    name
    serviceTerms
  }
`
export const TenantFieldsFragmentDoc = gql`
  fragment TenantFields on Tenant {
    id
    name
    companyName
    prefecture
    memo
    status
    introductionDate
    lastConversationDate
    lastInterviewDate
    createdAt
    setting {
      ...TenantSettingFields
    }
    users {
      ...UserFields
    }
    tenantPlan {
      id
      planId
      quoteNumber
      plan {
        ...PlanFields
      }
    }
  }
  ${TenantSettingFieldsFragmentDoc}
  ${UserFieldsFragmentDoc}
  ${PlanFieldsFragmentDoc}
`
export const TenantSimpleFieldsFragmentDoc = gql`
  fragment TenantSimpleFields on Tenant {
    id
    name
    companyName
    prefecture
    status
    memo
    introductionDate
    lastConversationDate
    lastInterviewDate
    createdAt
    tenantPlan {
      id
      planId
      quoteNumber
      plan {
        ...PlanFields
      }
    }
  }
  ${PlanFieldsFragmentDoc}
`
export const CreateInvitationDocument = gql`
  mutation createInvitation($input: CreateInvitationInput!) {
    createInvitation(input: $input) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`
export type CreateInvitationMutationFn = Apollo.MutationFunction<
  CreateInvitationMutation,
  CreateInvitationMutationVariables
>

/**
 * __useCreateInvitationMutation__
 *
 * To run a mutation, you first call `useCreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationMutation, { data, loading, error }] = useCreateInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInvitationMutation, CreateInvitationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInvitationMutation, CreateInvitationMutationVariables>(
    CreateInvitationDocument,
    options,
  )
}
export type CreateInvitationMutationHookResult = ReturnType<typeof useCreateInvitationMutation>
export type CreateInvitationMutationResult = Apollo.MutationResult<CreateInvitationMutation>
export type CreateInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateInvitationMutation,
  CreateInvitationMutationVariables
>
export const AgreeToServiceTermsDocument = gql`
  mutation agreeToServiceTerms {
    agreeToServiceTerms {
      ...MeFields
    }
  }
  ${MeFieldsFragmentDoc}
`
export type AgreeToServiceTermsMutationFn = Apollo.MutationFunction<
  AgreeToServiceTermsMutation,
  AgreeToServiceTermsMutationVariables
>

/**
 * __useAgreeToServiceTermsMutation__
 *
 * To run a mutation, you first call `useAgreeToServiceTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToServiceTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToServiceTermsMutation, { data, loading, error }] = useAgreeToServiceTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAgreeToServiceTermsMutation(
  baseOptions?: Apollo.MutationHookOptions<AgreeToServiceTermsMutation, AgreeToServiceTermsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AgreeToServiceTermsMutation, AgreeToServiceTermsMutationVariables>(
    AgreeToServiceTermsDocument,
    options,
  )
}
export type AgreeToServiceTermsMutationHookResult = ReturnType<typeof useAgreeToServiceTermsMutation>
export type AgreeToServiceTermsMutationResult = Apollo.MutationResult<AgreeToServiceTermsMutation>
export type AgreeToServiceTermsMutationOptions = Apollo.BaseMutationOptions<
  AgreeToServiceTermsMutation,
  AgreeToServiceTermsMutationVariables
>
export const CreateAdminInvitationDocument = gql`
  mutation createAdminInvitation($input: CreateAdminInvitationInput!) {
    createAdminInvitation(input: $input) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`
export type CreateAdminInvitationMutationFn = Apollo.MutationFunction<
  CreateAdminInvitationMutation,
  CreateAdminInvitationMutationVariables
>

/**
 * __useCreateAdminInvitationMutation__
 *
 * To run a mutation, you first call `useCreateAdminInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminInvitationMutation, { data, loading, error }] = useCreateAdminInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAdminInvitationMutation, CreateAdminInvitationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAdminInvitationMutation, CreateAdminInvitationMutationVariables>(
    CreateAdminInvitationDocument,
    options,
  )
}
export type CreateAdminInvitationMutationHookResult = ReturnType<typeof useCreateAdminInvitationMutation>
export type CreateAdminInvitationMutationResult = Apollo.MutationResult<CreateAdminInvitationMutation>
export type CreateAdminInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateAdminInvitationMutation,
  CreateAdminInvitationMutationVariables
>
export const CreateAdminPlanDocument = gql`
  mutation createAdminPlan($plan: PlanCreateInput!) {
    createAdminPlan(plan: $plan) {
      ...PlanFields
    }
  }
  ${PlanFieldsFragmentDoc}
`
export type CreateAdminPlanMutationFn = Apollo.MutationFunction<
  CreateAdminPlanMutation,
  CreateAdminPlanMutationVariables
>

/**
 * __useCreateAdminPlanMutation__
 *
 * To run a mutation, you first call `useCreateAdminPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminPlanMutation, { data, loading, error }] = useCreateAdminPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useCreateAdminPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAdminPlanMutation, CreateAdminPlanMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAdminPlanMutation, CreateAdminPlanMutationVariables>(CreateAdminPlanDocument, options)
}
export type CreateAdminPlanMutationHookResult = ReturnType<typeof useCreateAdminPlanMutation>
export type CreateAdminPlanMutationResult = Apollo.MutationResult<CreateAdminPlanMutation>
export type CreateAdminPlanMutationOptions = Apollo.BaseMutationOptions<
  CreateAdminPlanMutation,
  CreateAdminPlanMutationVariables
>
export const CreateMillsheetsByCsvDocument = gql`
  mutation createMillsheetsByCsv($csv: String!) {
    createMillsheetsByCsv(csv: $csv) {
      ...CreateMillsheetsByCsvResultFields
    }
  }
  ${CreateMillsheetsByCsvResultFieldsFragmentDoc}
`
export type CreateMillsheetsByCsvMutationFn = Apollo.MutationFunction<
  CreateMillsheetsByCsvMutation,
  CreateMillsheetsByCsvMutationVariables
>

/**
 * __useCreateMillsheetsByCsvMutation__
 *
 * To run a mutation, you first call `useCreateMillsheetsByCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMillsheetsByCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMillsheetsByCsvMutation, { data, loading, error }] = useCreateMillsheetsByCsvMutation({
 *   variables: {
 *      csv: // value for 'csv'
 *   },
 * });
 */
export function useCreateMillsheetsByCsvMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateMillsheetsByCsvMutation, CreateMillsheetsByCsvMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateMillsheetsByCsvMutation, CreateMillsheetsByCsvMutationVariables>(
    CreateMillsheetsByCsvDocument,
    options,
  )
}
export type CreateMillsheetsByCsvMutationHookResult = ReturnType<typeof useCreateMillsheetsByCsvMutation>
export type CreateMillsheetsByCsvMutationResult = Apollo.MutationResult<CreateMillsheetsByCsvMutation>
export type CreateMillsheetsByCsvMutationOptions = Apollo.BaseMutationOptions<
  CreateMillsheetsByCsvMutation,
  CreateMillsheetsByCsvMutationVariables
>
export const CreateS3ObjectDocument = gql`
  mutation createS3Object($input: S3ObjectCreateInput!) {
    createS3Object(input: $input) {
      id
      fileUrl
      fileUrlForPut
    }
  }
`
export type CreateS3ObjectMutationFn = Apollo.MutationFunction<CreateS3ObjectMutation, CreateS3ObjectMutationVariables>

/**
 * __useCreateS3ObjectMutation__
 *
 * To run a mutation, you first call `useCreateS3ObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateS3ObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createS3ObjectMutation, { data, loading, error }] = useCreateS3ObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateS3ObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateS3ObjectMutation, CreateS3ObjectMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateS3ObjectMutation, CreateS3ObjectMutationVariables>(CreateS3ObjectDocument, options)
}
export type CreateS3ObjectMutationHookResult = ReturnType<typeof useCreateS3ObjectMutation>
export type CreateS3ObjectMutationResult = Apollo.MutationResult<CreateS3ObjectMutation>
export type CreateS3ObjectMutationOptions = Apollo.BaseMutationOptions<
  CreateS3ObjectMutation,
  CreateS3ObjectMutationVariables
>
export const CreateS3ObjectThumbnailsDocument = gql`
  mutation createS3ObjectThumbnails($s3ObjectId: ID!) {
    createS3ObjectThumbnails(s3ObjectId: $s3ObjectId) {
      id
      fileUrl
      thumbnailFileUrls
    }
  }
`
export type CreateS3ObjectThumbnailsMutationFn = Apollo.MutationFunction<
  CreateS3ObjectThumbnailsMutation,
  CreateS3ObjectThumbnailsMutationVariables
>

/**
 * __useCreateS3ObjectThumbnailsMutation__
 *
 * To run a mutation, you first call `useCreateS3ObjectThumbnailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateS3ObjectThumbnailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createS3ObjectThumbnailsMutation, { data, loading, error }] = useCreateS3ObjectThumbnailsMutation({
 *   variables: {
 *      s3ObjectId: // value for 's3ObjectId'
 *   },
 * });
 */
export function useCreateS3ObjectThumbnailsMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateS3ObjectThumbnailsMutation, CreateS3ObjectThumbnailsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateS3ObjectThumbnailsMutation, CreateS3ObjectThumbnailsMutationVariables>(
    CreateS3ObjectThumbnailsDocument,
    options,
  )
}
export type CreateS3ObjectThumbnailsMutationHookResult = ReturnType<typeof useCreateS3ObjectThumbnailsMutation>
export type CreateS3ObjectThumbnailsMutationResult = Apollo.MutationResult<CreateS3ObjectThumbnailsMutation>
export type CreateS3ObjectThumbnailsMutationOptions = Apollo.BaseMutationOptions<
  CreateS3ObjectThumbnailsMutation,
  CreateS3ObjectThumbnailsMutationVariables
>
export const CreateTenantDocument = gql`
  mutation createTenant($tenant: AdminTenantCreateInput!) {
    createAdminTenant(tenant: $tenant) {
      ...TenantFields
    }
  }
  ${TenantFieldsFragmentDoc}
`
export type CreateTenantMutationFn = Apollo.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateTenantMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, options)
}
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>
export type CreateTenantMutationResult = Apollo.MutationResult<CreateTenantMutation>
export type CreateTenantMutationOptions = Apollo.BaseMutationOptions<
  CreateTenantMutation,
  CreateTenantMutationVariables
>
export const DeleteAdminPlanDocument = gql`
  mutation deleteAdminPlan($id: ID!) {
    deleteAdminPlan(id: $id) {
      ...PlanFields
    }
  }
  ${PlanFieldsFragmentDoc}
`
export type DeleteAdminPlanMutationFn = Apollo.MutationFunction<
  DeleteAdminPlanMutation,
  DeleteAdminPlanMutationVariables
>

/**
 * __useDeleteAdminPlanMutation__
 *
 * To run a mutation, you first call `useDeleteAdminPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminPlanMutation, { data, loading, error }] = useDeleteAdminPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAdminPlanMutation, DeleteAdminPlanMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteAdminPlanMutation, DeleteAdminPlanMutationVariables>(DeleteAdminPlanDocument, options)
}
export type DeleteAdminPlanMutationHookResult = ReturnType<typeof useDeleteAdminPlanMutation>
export type DeleteAdminPlanMutationResult = Apollo.MutationResult<DeleteAdminPlanMutation>
export type DeleteAdminPlanMutationOptions = Apollo.BaseMutationOptions<
  DeleteAdminPlanMutation,
  DeleteAdminPlanMutationVariables
>
export const DeleteAdminUserDocument = gql`
  mutation deleteAdminUser($id: ID!) {
    deleteAdminUser(id: $id) {
      id
    }
  }
`
export type DeleteAdminUserMutationFn = Apollo.MutationFunction<
  DeleteAdminUserMutation,
  DeleteAdminUserMutationVariables
>

/**
 * __useDeleteAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserMutation, { data, loading, error }] = useDeleteAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(DeleteAdminUserDocument, options)
}
export type DeleteAdminUserMutationHookResult = ReturnType<typeof useDeleteAdminUserMutation>
export type DeleteAdminUserMutationResult = Apollo.MutationResult<DeleteAdminUserMutation>
export type DeleteAdminUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteAdminUserMutation,
  DeleteAdminUserMutationVariables
>
export const DeleteMillsheetDocument = gql`
  mutation deleteMillsheet($id: ID!) {
    deleteMillsheet(id: $id) {
      ...MillsheetFields
    }
  }
  ${MillsheetFieldsFragmentDoc}
`
export type DeleteMillsheetMutationFn = Apollo.MutationFunction<
  DeleteMillsheetMutation,
  DeleteMillsheetMutationVariables
>

/**
 * __useDeleteMillsheetMutation__
 *
 * To run a mutation, you first call `useDeleteMillsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMillsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMillsheetMutation, { data, loading, error }] = useDeleteMillsheetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMillsheetMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteMillsheetMutation, DeleteMillsheetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteMillsheetMutation, DeleteMillsheetMutationVariables>(DeleteMillsheetDocument, options)
}
export type DeleteMillsheetMutationHookResult = ReturnType<typeof useDeleteMillsheetMutation>
export type DeleteMillsheetMutationResult = Apollo.MutationResult<DeleteMillsheetMutation>
export type DeleteMillsheetMutationOptions = Apollo.BaseMutationOptions<
  DeleteMillsheetMutation,
  DeleteMillsheetMutationVariables
>
export const DeleteS3ObjectDocument = gql`
  mutation deleteS3Object($id: ID!) {
    deleteS3Object(id: $id) {
      id
    }
  }
`
export type DeleteS3ObjectMutationFn = Apollo.MutationFunction<DeleteS3ObjectMutation, DeleteS3ObjectMutationVariables>

/**
 * __useDeleteS3ObjectMutation__
 *
 * To run a mutation, you first call `useDeleteS3ObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteS3ObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteS3ObjectMutation, { data, loading, error }] = useDeleteS3ObjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteS3ObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteS3ObjectMutation, DeleteS3ObjectMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteS3ObjectMutation, DeleteS3ObjectMutationVariables>(DeleteS3ObjectDocument, options)
}
export type DeleteS3ObjectMutationHookResult = ReturnType<typeof useDeleteS3ObjectMutation>
export type DeleteS3ObjectMutationResult = Apollo.MutationResult<DeleteS3ObjectMutation>
export type DeleteS3ObjectMutationOptions = Apollo.BaseMutationOptions<
  DeleteS3ObjectMutation,
  DeleteS3ObjectMutationVariables
>
export const DeleteTenantDocument = gql`
  mutation deleteTenant($id: ID!) {
    deleteAdminTenant(id: $id) {
      ...TenantFields
    }
  }
  ${TenantFieldsFragmentDoc}
`
export type DeleteTenantMutationFn = Apollo.MutationFunction<DeleteTenantMutation, DeleteTenantMutationVariables>

/**
 * __useDeleteTenantMutation__
 *
 * To run a mutation, you first call `useDeleteTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantMutation, { data, loading, error }] = useDeleteTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTenantMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTenantMutation, DeleteTenantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTenantMutation, DeleteTenantMutationVariables>(DeleteTenantDocument, options)
}
export type DeleteTenantMutationHookResult = ReturnType<typeof useDeleteTenantMutation>
export type DeleteTenantMutationResult = Apollo.MutationResult<DeleteTenantMutation>
export type DeleteTenantMutationOptions = Apollo.BaseMutationOptions<
  DeleteTenantMutation,
  DeleteTenantMutationVariables
>
export const DeleteUserDocument = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
    }
  }
`
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options)
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>
export const UpdateAdminPlanDocument = gql`
  mutation updateAdminPlan($plan: PlanUpdateInput!) {
    updateAdminPlan(plan: $plan) {
      ...PlanFields
    }
  }
  ${PlanFieldsFragmentDoc}
`
export type UpdateAdminPlanMutationFn = Apollo.MutationFunction<
  UpdateAdminPlanMutation,
  UpdateAdminPlanMutationVariables
>

/**
 * __useUpdateAdminPlanMutation__
 *
 * To run a mutation, you first call `useUpdateAdminPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminPlanMutation, { data, loading, error }] = useUpdateAdminPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useUpdateAdminPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAdminPlanMutation, UpdateAdminPlanMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateAdminPlanMutation, UpdateAdminPlanMutationVariables>(UpdateAdminPlanDocument, options)
}
export type UpdateAdminPlanMutationHookResult = ReturnType<typeof useUpdateAdminPlanMutation>
export type UpdateAdminPlanMutationResult = Apollo.MutationResult<UpdateAdminPlanMutation>
export type UpdateAdminPlanMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdminPlanMutation,
  UpdateAdminPlanMutationVariables
>
export const UpdateMillsheetDocument = gql`
  mutation updateMillsheet($input: MillsheetUpdateInput!) {
    updateMillsheet(input: $input) {
      ...MillsheetFields
    }
  }
  ${MillsheetFieldsFragmentDoc}
`
export type UpdateMillsheetMutationFn = Apollo.MutationFunction<
  UpdateMillsheetMutation,
  UpdateMillsheetMutationVariables
>

/**
 * __useUpdateMillsheetMutation__
 *
 * To run a mutation, you first call `useUpdateMillsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMillsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMillsheetMutation, { data, loading, error }] = useUpdateMillsheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMillsheetMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateMillsheetMutation, UpdateMillsheetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateMillsheetMutation, UpdateMillsheetMutationVariables>(UpdateMillsheetDocument, options)
}
export type UpdateMillsheetMutationHookResult = ReturnType<typeof useUpdateMillsheetMutation>
export type UpdateMillsheetMutationResult = Apollo.MutationResult<UpdateMillsheetMutation>
export type UpdateMillsheetMutationOptions = Apollo.BaseMutationOptions<
  UpdateMillsheetMutation,
  UpdateMillsheetMutationVariables
>
export const UpdateMillsheetsDocument = gql`
  mutation updateMillsheets($input: MillsheetsUpdateInput!) {
    updateMillsheets(input: $input) {
      ...MillsheetFields
    }
  }
  ${MillsheetFieldsFragmentDoc}
`
export type UpdateMillsheetsMutationFn = Apollo.MutationFunction<
  UpdateMillsheetsMutation,
  UpdateMillsheetsMutationVariables
>

/**
 * __useUpdateMillsheetsMutation__
 *
 * To run a mutation, you first call `useUpdateMillsheetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMillsheetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMillsheetsMutation, { data, loading, error }] = useUpdateMillsheetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMillsheetsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateMillsheetsMutation, UpdateMillsheetsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateMillsheetsMutation, UpdateMillsheetsMutationVariables>(
    UpdateMillsheetsDocument,
    options,
  )
}
export type UpdateMillsheetsMutationHookResult = ReturnType<typeof useUpdateMillsheetsMutation>
export type UpdateMillsheetsMutationResult = Apollo.MutationResult<UpdateMillsheetsMutation>
export type UpdateMillsheetsMutationOptions = Apollo.BaseMutationOptions<
  UpdateMillsheetsMutation,
  UpdateMillsheetsMutationVariables
>
export const UpdateS3ObjectDocument = gql`
  mutation updateS3Object($input: S3ObjectUpdateInput!) {
    updateS3Object(input: $input) {
      id
    }
  }
`
export type UpdateS3ObjectMutationFn = Apollo.MutationFunction<UpdateS3ObjectMutation, UpdateS3ObjectMutationVariables>

/**
 * __useUpdateS3ObjectMutation__
 *
 * To run a mutation, you first call `useUpdateS3ObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateS3ObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateS3ObjectMutation, { data, loading, error }] = useUpdateS3ObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateS3ObjectMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateS3ObjectMutation, UpdateS3ObjectMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateS3ObjectMutation, UpdateS3ObjectMutationVariables>(UpdateS3ObjectDocument, options)
}
export type UpdateS3ObjectMutationHookResult = ReturnType<typeof useUpdateS3ObjectMutation>
export type UpdateS3ObjectMutationResult = Apollo.MutationResult<UpdateS3ObjectMutation>
export type UpdateS3ObjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateS3ObjectMutation,
  UpdateS3ObjectMutationVariables
>
export const UpdateTenantDocument = gql`
  mutation updateTenant($tenant: AdminTenantUpdateInput!) {
    updateAdminTenant(tenant: $tenant) {
      ...TenantFields
    }
  }
  ${TenantFieldsFragmentDoc}
`
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useUpdateTenantMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options)
}
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<
  UpdateTenantMutation,
  UpdateTenantMutationVariables
>
export const UpdateTenantSettingDocument = gql`
  mutation updateTenantSetting($input: TenantSettingUpdateInput!) {
    updateTenantSetting(input: $input) {
      ...TenantSettingFields
    }
  }
  ${TenantSettingFieldsFragmentDoc}
`
export type UpdateTenantSettingMutationFn = Apollo.MutationFunction<
  UpdateTenantSettingMutation,
  UpdateTenantSettingMutationVariables
>

/**
 * __useUpdateTenantSettingMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSettingMutation, { data, loading, error }] = useUpdateTenantSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTenantSettingMutation, UpdateTenantSettingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTenantSettingMutation, UpdateTenantSettingMutationVariables>(
    UpdateTenantSettingDocument,
    options,
  )
}
export type UpdateTenantSettingMutationHookResult = ReturnType<typeof useUpdateTenantSettingMutation>
export type UpdateTenantSettingMutationResult = Apollo.MutationResult<UpdateTenantSettingMutation>
export type UpdateTenantSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateTenantSettingMutation,
  UpdateTenantSettingMutationVariables
>
export const UpdateUserDocument = gql`
  mutation updateUser($input: UserInput!) {
    updateUser(input: $input) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options)
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>
export const UpsertAdminTenantSettingDocument = gql`
  mutation upsertAdminTenantSetting($tenantSetting: AdminTenantSettingUpdateInput!) {
    upsertAdminTenantSetting(input: $tenantSetting) {
      ...TenantSettingFields
    }
  }
  ${TenantSettingFieldsFragmentDoc}
`
export type UpsertAdminTenantSettingMutationFn = Apollo.MutationFunction<
  UpsertAdminTenantSettingMutation,
  UpsertAdminTenantSettingMutationVariables
>

/**
 * __useUpsertAdminTenantSettingMutation__
 *
 * To run a mutation, you first call `useUpsertAdminTenantSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAdminTenantSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAdminTenantSettingMutation, { data, loading, error }] = useUpsertAdminTenantSettingMutation({
 *   variables: {
 *      tenantSetting: // value for 'tenantSetting'
 *   },
 * });
 */
export function useUpsertAdminTenantSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertAdminTenantSettingMutation, UpsertAdminTenantSettingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertAdminTenantSettingMutation, UpsertAdminTenantSettingMutationVariables>(
    UpsertAdminTenantSettingDocument,
    options,
  )
}
export type UpsertAdminTenantSettingMutationHookResult = ReturnType<typeof useUpsertAdminTenantSettingMutation>
export type UpsertAdminTenantSettingMutationResult = Apollo.MutationResult<UpsertAdminTenantSettingMutation>
export type UpsertAdminTenantSettingMutationOptions = Apollo.BaseMutationOptions<
  UpsertAdminTenantSettingMutation,
  UpsertAdminTenantSettingMutationVariables
>
export const FetchAdminS3ObjectDocument = gql`
  query fetchAdminS3Object($id: ID!) {
    adminS3Object(id: $id) {
      id
      originalFileName
      resourceType
      extension
      contentType
      contentLength
      thumbnailCount
      imageWidth
      imageHeight
      fileUrl
      createdAt
      thumbnailFileUrls
    }
  }
`

/**
 * __useFetchAdminS3ObjectQuery__
 *
 * To run a query within a React component, call `useFetchAdminS3ObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminS3ObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminS3ObjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAdminS3ObjectQuery(
  baseOptions: Apollo.QueryHookOptions<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables> &
    ({ variables: FetchAdminS3ObjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>(FetchAdminS3ObjectDocument, options)
}
export function useFetchAdminS3ObjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>(
    FetchAdminS3ObjectDocument,
    options,
  )
}
export function useFetchAdminS3ObjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>(
    FetchAdminS3ObjectDocument,
    options,
  )
}
export type FetchAdminS3ObjectQueryHookResult = ReturnType<typeof useFetchAdminS3ObjectQuery>
export type FetchAdminS3ObjectLazyQueryHookResult = ReturnType<typeof useFetchAdminS3ObjectLazyQuery>
export type FetchAdminS3ObjectSuspenseQueryHookResult = ReturnType<typeof useFetchAdminS3ObjectSuspenseQuery>
export type FetchAdminS3ObjectQueryResult = Apollo.QueryResult<
  FetchAdminS3ObjectQuery,
  FetchAdminS3ObjectQueryVariables
>
export const FetchAdminTenantsDocument = gql`
  query fetchAdminTenants {
    adminTenants {
      total
      tenants {
        ...TenantFields
      }
    }
  }
  ${TenantFieldsFragmentDoc}
`

/**
 * __useFetchAdminTenantsQuery__
 *
 * To run a query within a React component, call `useFetchAdminTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAdminTenantsQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>(FetchAdminTenantsDocument, options)
}
export function useFetchAdminTenantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>(
    FetchAdminTenantsDocument,
    options,
  )
}
export function useFetchAdminTenantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>(
    FetchAdminTenantsDocument,
    options,
  )
}
export type FetchAdminTenantsQueryHookResult = ReturnType<typeof useFetchAdminTenantsQuery>
export type FetchAdminTenantsLazyQueryHookResult = ReturnType<typeof useFetchAdminTenantsLazyQuery>
export type FetchAdminTenantsSuspenseQueryHookResult = ReturnType<typeof useFetchAdminTenantsSuspenseQuery>
export type FetchAdminTenantsQueryResult = Apollo.QueryResult<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>
export const FetchDashboardDocument = gql`
  query fetchDashboard {
    dashboard {
      millsheetsCount
      tenantPlan {
        id
        quoteNumber
        plan {
          ...PlanFields
        }
      }
    }
  }
  ${PlanFieldsFragmentDoc}
`

/**
 * __useFetchDashboardQuery__
 *
 * To run a query within a React component, call `useFetchDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDashboardQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchDashboardQuery, FetchDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchDashboardQuery, FetchDashboardQueryVariables>(FetchDashboardDocument, options)
}
export function useFetchDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchDashboardQuery, FetchDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchDashboardQuery, FetchDashboardQueryVariables>(FetchDashboardDocument, options)
}
export function useFetchDashboardSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDashboardQuery, FetchDashboardQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchDashboardQuery, FetchDashboardQueryVariables>(FetchDashboardDocument, options)
}
export type FetchDashboardQueryHookResult = ReturnType<typeof useFetchDashboardQuery>
export type FetchDashboardLazyQueryHookResult = ReturnType<typeof useFetchDashboardLazyQuery>
export type FetchDashboardSuspenseQueryHookResult = ReturnType<typeof useFetchDashboardSuspenseQuery>
export type FetchDashboardQueryResult = Apollo.QueryResult<FetchDashboardQuery, FetchDashboardQueryVariables>
export const FetchMeDocument = gql`
  query fetchMe {
    me {
      ...MeFields
    }
  }
  ${MeFieldsFragmentDoc}
`

/**
 * __useFetchMeQuery__
 *
 * To run a query within a React component, call `useFetchMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMeQuery(baseOptions?: Apollo.QueryHookOptions<FetchMeQuery, FetchMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchMeQuery, FetchMeQueryVariables>(FetchMeDocument, options)
}
export function useFetchMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMeQuery, FetchMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchMeQuery, FetchMeQueryVariables>(FetchMeDocument, options)
}
export function useFetchMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchMeQuery, FetchMeQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchMeQuery, FetchMeQueryVariables>(FetchMeDocument, options)
}
export type FetchMeQueryHookResult = ReturnType<typeof useFetchMeQuery>
export type FetchMeLazyQueryHookResult = ReturnType<typeof useFetchMeLazyQuery>
export type FetchMeSuspenseQueryHookResult = ReturnType<typeof useFetchMeSuspenseQuery>
export type FetchMeQueryResult = Apollo.QueryResult<FetchMeQuery, FetchMeQueryVariables>
export const FetchMillsheetItemsDocument = gql`
  query fetchMillsheetItems($heatNumber: String!) {
    millsheetItems(heatNumber: $heatNumber) {
      ...MillsheetItemFields
      millsheetNo
    }
  }
  ${MillsheetItemFieldsFragmentDoc}
`

/**
 * __useFetchMillsheetItemsQuery__
 *
 * To run a query within a React component, call `useFetchMillsheetItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMillsheetItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMillsheetItemsQuery({
 *   variables: {
 *      heatNumber: // value for 'heatNumber'
 *   },
 * });
 */
export function useFetchMillsheetItemsQuery(
  baseOptions: Apollo.QueryHookOptions<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables> &
    ({ variables: FetchMillsheetItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>(
    FetchMillsheetItemsDocument,
    options,
  )
}
export function useFetchMillsheetItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>(
    FetchMillsheetItemsDocument,
    options,
  )
}
export function useFetchMillsheetItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>(
    FetchMillsheetItemsDocument,
    options,
  )
}
export type FetchMillsheetItemsQueryHookResult = ReturnType<typeof useFetchMillsheetItemsQuery>
export type FetchMillsheetItemsLazyQueryHookResult = ReturnType<typeof useFetchMillsheetItemsLazyQuery>
export type FetchMillsheetItemsSuspenseQueryHookResult = ReturnType<typeof useFetchMillsheetItemsSuspenseQuery>
export type FetchMillsheetItemsQueryResult = Apollo.QueryResult<
  FetchMillsheetItemsQuery,
  FetchMillsheetItemsQueryVariables
>
export const FetchMillsheetsDocument = gql`
  query fetchMillsheets {
    millsheets {
      ...MillsheetFields
    }
  }
  ${MillsheetFieldsFragmentDoc}
`

/**
 * __useFetchMillsheetsQuery__
 *
 * To run a query within a React component, call `useFetchMillsheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMillsheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMillsheetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMillsheetsQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>(FetchMillsheetsDocument, options)
}
export function useFetchMillsheetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>(FetchMillsheetsDocument, options)
}
export function useFetchMillsheetsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>(FetchMillsheetsDocument, options)
}
export type FetchMillsheetsQueryHookResult = ReturnType<typeof useFetchMillsheetsQuery>
export type FetchMillsheetsLazyQueryHookResult = ReturnType<typeof useFetchMillsheetsLazyQuery>
export type FetchMillsheetsSuspenseQueryHookResult = ReturnType<typeof useFetchMillsheetsSuspenseQuery>
export type FetchMillsheetsQueryResult = Apollo.QueryResult<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>
export const FetchMyIdentityDocument = gql`
  query fetchMyIdentity {
    myIdentity {
      ...MyIdentityFields
    }
  }
  ${MyIdentityFieldsFragmentDoc}
`

/**
 * __useFetchMyIdentityQuery__
 *
 * To run a query within a React component, call `useFetchMyIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyIdentityQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>(FetchMyIdentityDocument, options)
}
export function useFetchMyIdentityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>(FetchMyIdentityDocument, options)
}
export function useFetchMyIdentitySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>(FetchMyIdentityDocument, options)
}
export type FetchMyIdentityQueryHookResult = ReturnType<typeof useFetchMyIdentityQuery>
export type FetchMyIdentityLazyQueryHookResult = ReturnType<typeof useFetchMyIdentityLazyQuery>
export type FetchMyIdentitySuspenseQueryHookResult = ReturnType<typeof useFetchMyIdentitySuspenseQuery>
export type FetchMyIdentityQueryResult = Apollo.QueryResult<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>
export const FetchMyTenantDetailDocument = gql`
  query fetchMyTenantDetail {
    me {
      name
      tenant {
        name
        tenantPlan {
          id
          quoteNumber
          plan {
            id
            name
            serviceTerms
          }
        }
      }
    }
  }
`

/**
 * __useFetchMyTenantDetailQuery__
 *
 * To run a query within a React component, call `useFetchMyTenantDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyTenantDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyTenantDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyTenantDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>(
    FetchMyTenantDetailDocument,
    options,
  )
}
export function useFetchMyTenantDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>(
    FetchMyTenantDetailDocument,
    options,
  )
}
export function useFetchMyTenantDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>(
    FetchMyTenantDetailDocument,
    options,
  )
}
export type FetchMyTenantDetailQueryHookResult = ReturnType<typeof useFetchMyTenantDetailQuery>
export type FetchMyTenantDetailLazyQueryHookResult = ReturnType<typeof useFetchMyTenantDetailLazyQuery>
export type FetchMyTenantDetailSuspenseQueryHookResult = ReturnType<typeof useFetchMyTenantDetailSuspenseQuery>
export type FetchMyTenantDetailQueryResult = Apollo.QueryResult<
  FetchMyTenantDetailQuery,
  FetchMyTenantDetailQueryVariables
>
export const FetchAdminPlansDocument = gql`
  query fetchAdminPlans {
    adminPlans {
      ...PlanFields
    }
  }
  ${PlanFieldsFragmentDoc}
`

/**
 * __useFetchAdminPlansQuery__
 *
 * To run a query within a React component, call `useFetchAdminPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAdminPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>(FetchAdminPlansDocument, options)
}
export function useFetchAdminPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>(FetchAdminPlansDocument, options)
}
export function useFetchAdminPlansSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>(FetchAdminPlansDocument, options)
}
export type FetchAdminPlansQueryHookResult = ReturnType<typeof useFetchAdminPlansQuery>
export type FetchAdminPlansLazyQueryHookResult = ReturnType<typeof useFetchAdminPlansLazyQuery>
export type FetchAdminPlansSuspenseQueryHookResult = ReturnType<typeof useFetchAdminPlansSuspenseQuery>
export type FetchAdminPlansQueryResult = Apollo.QueryResult<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>
export const FetchS3ObjectsDocument = gql`
  query fetchS3Objects($ids: [String!], $notConnectedOnly: Boolean) {
    s3Objects(ids: $ids, notConnectedOnly: $notConnectedOnly) {
      id
      originalFileName
      resourceType
      extension
      contentType
      contentLength
      thumbnailCount
      imageWidth
      imageHeight
      fileUrl
      createdAt
      thumbnailFileUrls
    }
  }
`

/**
 * __useFetchS3ObjectsQuery__
 *
 * To run a query within a React component, call `useFetchS3ObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchS3ObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchS3ObjectsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      notConnectedOnly: // value for 'notConnectedOnly'
 *   },
 * });
 */
export function useFetchS3ObjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>(FetchS3ObjectsDocument, options)
}
export function useFetchS3ObjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>(FetchS3ObjectsDocument, options)
}
export function useFetchS3ObjectsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>(FetchS3ObjectsDocument, options)
}
export type FetchS3ObjectsQueryHookResult = ReturnType<typeof useFetchS3ObjectsQuery>
export type FetchS3ObjectsLazyQueryHookResult = ReturnType<typeof useFetchS3ObjectsLazyQuery>
export type FetchS3ObjectsSuspenseQueryHookResult = ReturnType<typeof useFetchS3ObjectsSuspenseQuery>
export type FetchS3ObjectsQueryResult = Apollo.QueryResult<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>
export const FetchTenantDocument = gql`
  query fetchTenant($id: ID!) {
    adminTenant(id: $id) {
      ...TenantFields
    }
  }
  ${TenantFieldsFragmentDoc}
`

/**
 * __useFetchTenantQuery__
 *
 * To run a query within a React component, call `useFetchTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTenantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchTenantQuery(
  baseOptions: Apollo.QueryHookOptions<FetchTenantQuery, FetchTenantQueryVariables> &
    ({ variables: FetchTenantQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchTenantQuery, FetchTenantQueryVariables>(FetchTenantDocument, options)
}
export function useFetchTenantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchTenantQuery, FetchTenantQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchTenantQuery, FetchTenantQueryVariables>(FetchTenantDocument, options)
}
export function useFetchTenantSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTenantQuery, FetchTenantQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchTenantQuery, FetchTenantQueryVariables>(FetchTenantDocument, options)
}
export type FetchTenantQueryHookResult = ReturnType<typeof useFetchTenantQuery>
export type FetchTenantLazyQueryHookResult = ReturnType<typeof useFetchTenantLazyQuery>
export type FetchTenantSuspenseQueryHookResult = ReturnType<typeof useFetchTenantSuspenseQuery>
export type FetchTenantQueryResult = Apollo.QueryResult<FetchTenantQuery, FetchTenantQueryVariables>
export const FetchTenantsDocument = gql`
  query fetchTenants {
    adminTenants {
      total
      tenants {
        ...TenantSimpleFields
      }
    }
  }
  ${TenantSimpleFieldsFragmentDoc}
`

/**
 * __useFetchTenantsQuery__
 *
 * To run a query within a React component, call `useFetchTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchTenantsQuery(
  baseOptions?: Apollo.QueryHookOptions<FetchTenantsQuery, FetchTenantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchTenantsQuery, FetchTenantsQueryVariables>(FetchTenantsDocument, options)
}
export function useFetchTenantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchTenantsQuery, FetchTenantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchTenantsQuery, FetchTenantsQueryVariables>(FetchTenantsDocument, options)
}
export function useFetchTenantsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTenantsQuery, FetchTenantsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchTenantsQuery, FetchTenantsQueryVariables>(FetchTenantsDocument, options)
}
export type FetchTenantsQueryHookResult = ReturnType<typeof useFetchTenantsQuery>
export type FetchTenantsLazyQueryHookResult = ReturnType<typeof useFetchTenantsLazyQuery>
export type FetchTenantsSuspenseQueryHookResult = ReturnType<typeof useFetchTenantsSuspenseQuery>
export type FetchTenantsQueryResult = Apollo.QueryResult<FetchTenantsQuery, FetchTenantsQueryVariables>
export const FetchUsersDocument = gql`
  query fetchUsers {
    users {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`

/**
 * __useFetchUsersQuery__
 *
 * To run a query within a React component, call `useFetchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchUsersQuery(baseOptions?: Apollo.QueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options)
}
export function useFetchUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options)
}
export function useFetchUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUsersQuery, FetchUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, options)
}
export type FetchUsersQueryHookResult = ReturnType<typeof useFetchUsersQuery>
export type FetchUsersLazyQueryHookResult = ReturnType<typeof useFetchUsersLazyQuery>
export type FetchUsersSuspenseQueryHookResult = ReturnType<typeof useFetchUsersSuspenseQuery>
export type FetchUsersQueryResult = Apollo.QueryResult<FetchUsersQuery, FetchUsersQueryVariables>
